const ProjectItems = [
    {
        id: 0,
        cover: 'https://res.cloudinary.com/dmazpbyhl/image/upload/v1652073131/Capture_kclbhw.png',
        title: 'Google Search Clone',
        description: 'An attempt to clone UI, auto-suggest & google search results functionalities using React & Styled Components. Currently, auto-suggest works only for keywords "elon musk" and "coffee".',
        tech: ["React", "NodeJS", "Express", "MongoDB"],
        github: 'https://github.com/neerajmasai/google-search-engine',
        demo: 'https://google-search-engine-eight.vercel.app/',

    },
    {
        id: 1,
        cover: 'https://res.cloudinary.com/dmazpbyhl/image/upload/v1649356206/yatra_kbbidh.png',
        title: 'Yatra Clone',
        description: 'Yatra.com is a travel website that allows users to book flights, hotels, and car rentals. I was responsible for the back-end development of the website. Using React, I also built the Flight Search Component.',
        tech: ["React", "NodeJS", "Express", "MongoDB"],
        github: 'https://github.com/neerajmasai/yatra-clone',
        demo: 'https://yatraa.netlify.app/',

    },
    {
        id: 2,
        cover: 'https://res.cloudinary.com/dmazpbyhl/image/upload/v1649356207/nordstrom_c9y2hm.png',
        title: 'Nordstrom Clone',
        description: 'Nordstrom.com is an ecommerce website that sells clothing, shoes, and other accessories. I worked on key features such as Product Page, Cart, User Purchases & Built a REST API for the website.',
        tech: ["HTML", "CSS", "JavaScript", "Express", "MongoDB"],
        github: 'https://github.com/neerajmasai/nordstrom-website-clone',
        demo: 'https://nordstrom-clone-bay.vercel.app/',
    },
    {
        id: 3,
        cover: 'https://res.cloudinary.com/dmazpbyhl/image/upload/v1649703360/Capture_bmyax8.png',
        title: 'Gym Website',
        description: 'Built this website as part of freelancing. This is a live product that is currently being used by real customers. I built the complete end-to-end website from scratch using Wordpress.',
        tech: ["HTML", "CSS", "Wordpress"],
        github: "not available",
        demo: 'https://classicgym.in/',
    },
    {
        id: 4,
        cover: 'https://res.cloudinary.com/dmazpbyhl/image/upload/v1652076682/Capture_bcue0r.png',
        title: 'Grocery List App',
        description: 'A simple Grocery List App, add items, mark as purchased, save to wish list.',
        tech: ["React", "HTML", "CSS"],
        github: "https://github.com/neerajmasai/Todo-App-Groceries",
        demo: 'https://todo-app-groceries.vercel.app/',
    },
];

export default ProjectItems;